import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faUserCircle } from '@fortawesome/free-solid-svg-icons';
import { useFormikContext } from 'formik';

import { getImageBaseUrl } from '../../utilities/Image';
import { toast } from "react-toastify";
import DialogModal from './image-dialog-wizard';
import { storeMasterImage } from "../../services/enrolmentService";
import { TranslationKeys } from '../../contexts/TranslationKeys';
import { useLocale } from '../../contexts/localeContext';
import { getErrorMessage } from '../../services/utilities/ServiceError';
import { useDialog } from '../dialog/DialogContext';

function UserImage({ setImageOne, setImageTwo, setImageThree, primary, handleSubmit, onSetPrimary }) {
    const [image, setImage] = useState({ preview: "", raw: "" });
    const { values } = useFormikContext<any>();
    const [dialogOpen, setDialogOpen] = useState(false)
    const [currentlySeletedImage, setCurrentlySeletedImage] = useState(null) as any
    const [reloadPage, setReloadPage] = useState(false)
    const { translate } = useLocale();
    const [newImages, setNewImages] = useState([]);
    const dialog = useDialog();

    let oldImages = {

        image1: {
            id: 1,
            image: values.masterImages?.find(image => image.masterTypeId === 1)?.base64Thumb || '',
            masterImageId: values.masterImages?.find(image => image.masterTypeId === 1)?.id || ''
        },
        image2: {
            id: 2,
            image: values.masterImages?.find(image => image.masterTypeId === 2)?.base64Thumb || '',
            masterImageId: values.masterImages?.find(image => image.masterTypeId === 2)?.id || ''
        },
        image3: {
            id: 3,
            image: values.masterImages?.find(image => image.masterTypeId === 3)?.base64Thumb || '',
            masterImageId: values.masterImages?.find(image => image.masterTypeId === 3)?.id || ''
        }
    } as any

    const handleImageDelete = async (item) => {
        setReloadPage(true);
        const toBeDeleted = newImages[`image${item.masterImageId}`];
        const newMasterImage = { [`image${item.id}`]: { ...toBeDeleted, id: item.id, image: '', masterImageId: '' } };
        oldImages = { ...newImages, ...newMasterImage };
        setCurrentlySeletedImage({ ...item, image: '', masterImageId: '' });
        setNewImages(oldImages);
    }

    const setUploadNewImage = async (item, resetImageBox, setImageName) => {
        const master = {
            imageString: item.image,
            masterId: values.id,
            masterImageType: item.id,
            id: item.masterImageId ? item.masterImageId : 0
        }

        await storeMasterImage(master)
            .then((masterImage: any) => {

                setReloadPage(true);
                let toBeUpdated = newImages[`image${item.id}`];
                const newSelectedImage = { ...toBeUpdated, image: item.image, masterImageId: masterImage.id }
                const newMasterImage = { [`image${item.id}`]: { ...toBeUpdated, id: item.id, image: item.image, masterImageId: masterImage.id } };
                setCurrentlySeletedImage(newSelectedImage)
                oldImages = { ...newImages, ...newMasterImage };
                setNewImages(oldImages);
                toast.success(translate.byKey(TranslationKeys.imageSaved))

            }).catch((e) => {
                const toBeUpdated = newImages[`image${item.id}`];
                setImageName('')
                resetImageBox(toBeUpdated?.image)
                setReloadPage(false);
                dialog.pushError({ title: translate.byKey(TranslationKeys.error), message: getErrorMessage(e) })
                setNewImages(newImages);
            })
    }

    const onSelectedImage = (item) => {
        setCurrentlySeletedImage(item)
    }
    const handleClose = () => {
        setDialogOpen(false)
        if (reloadPage) handleSubmit();
        setReloadPage(false)
    }

    useEffect(() => {
        setNewImages(oldImages)
        setCurrentlySeletedImage(oldImages.image1)
        setImageOne(getImageBaseUrl(values.masterImages, 1));
        setImageTwo(getImageBaseUrl(values.masterImages, 2));
        setImageThree(getImageBaseUrl(values.masterImages, 3));
        setImage({ preview: getImageBaseUrl(values.masterImages, primary), raw: "" })
    }, [values.id, primary, values.masterImages])

    return (<>
        <DialogModal onSetPrimary={onSetPrimary} setUploadNewImage={setUploadNewImage} handleImageDelete={handleImageDelete} selectedImage={currentlySeletedImage} onSelectedImage={onSelectedImage} masterImages={newImages.length !== 0 ? newImages : oldImages} onClose={handleClose} isOpen={dialogOpen} />
        <div className="flex-col" >
            <div className="flex flex-row justify-center">
                <div className="h-32 w-32 rounded-full border-2 border-gray-400 text-gray-400 ">
                    {image.preview ?
                        <img className="rounded-full w-full h-full object-contain"
                            src={`data:image/png;base64,${image.preview}`}
                            alt="user" />
                        : <FontAwesomeIcon
                            style={{ fontSize: 124 }}
                            icon={faUserCircle} />}
                </div>
            </div>
            {values.id ?
                <div className="flex flex-row justify-center">
                    <div className="h-8 w-8 -mt-5 rounded-full bg-lime text-white text-1xl justify-center" onClick={() => setDialogOpen(true)}>
                        {!getImageBaseUrl(values.masterImages, values.selectedImage) ?

                            <label style={{ right: '400px' }} htmlFor="upload-button" onClick={() => setDialogOpen(true)}>
                                <a href="#">
                                    <FontAwesomeIcon onClick={() => setDialogOpen(true)} style={{ marginLeft: '6px' }} icon={faPlus} />
                                </a>
                            </label>
                            :

                            <label htmlFor="upload-button">
                                <a href="#">
                                    <FontAwesomeIcon
                                        style={{ marginLeft: '6px' }}
                                        icon={faPlus} />
                                </a>
                            </label>
                        }
                    </div>
                </div> : null
            }

        </div>
    </>
    );
}

export default UserImage;
